import React, {Component} from 'react';
import Helmet from "react-helmet";

class HelmetScripts extends Component {

  state = {scrollY: null};

  handleScroll = (event) => {
    this.setState({
      scrollY: window.scrollY
    });
  };

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
  }

  render() {
    let scripts = this.props.scripts ? this.props.scripts : '';

    return (
      <Helmet>
        {scripts && scripts.length > 0 && (
          scripts.map((item, index) => {
            switch (item.type) {
              case "schema":
                return (
                  <script type="application/ld+json" key={index}>{`
                      ${item.script}
                    `}</script>
                );
              case "external":
                return (
                  <script src={item.script} key={index} async></script>
                );
              case "zendesk":
                if (this.state.scrollY > 100) {
                  return (
                    <script src={item.script} key={index} nonce="{random}" id="ze-snippet" async></script>
                  );
                } else {
                  return null;
                }
              case "simple":
                return (
                  <script key={index} async>{`
                        ${item.script}
                      `}</script>
                );
              default:
                return (
                  <script key={index} async>{`
                        ${item.script}
                      `}</script>
                );
            }
          })
        )}
      </Helmet>
    )
  }
}

export default HelmetScripts;